import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBaseWorld = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 2C9.50077 3.64301 10.3537 5.77522 10.4 8C10.3537 10.2248 9.50077 12.357 8 14M8 2C6.49923 3.64301 5.64635 5.77522 5.6 8C5.64635 10.2248 6.49923 12.357 8 14M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14M2.30001 6.2H13.7M2.3 9.8H13.7",
		stroke: "currentColor",
		strokeOpacity: .6,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIconBaseWorld;
